import { FC } from 'react'

import styled from 'styled-components'

import ExclamationIcon from 'src/Assets/Svg/pages-icons/ExclamationPayment.svg?react'
import ErrorIcon from 'src/Assets/Svg/pages-icons/ErrorPayment.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { FullScreenModal } from 'src/Components/FullScreenModal'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 40px 16px;
`

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 600px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 358px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`

const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`

const StyledErrorIcon = styled(ErrorIcon)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.mediumRed};
`

export interface PaymentStateScreenProps {
  title: string
  text: string
  isLoading: boolean
  isFailed: boolean
  isRetrying: boolean
  onCampaignsButtonClick: () => void
  onBalanceButtonClick: () => void
  onTryAnotherMethodClick: () => void
}

export const PaymentStateScreen: FC<PaymentStateScreenProps> = ({
  title,
  text,
  isLoading,
  isFailed,
  isRetrying,
  onCampaignsButtonClick,
  onBalanceButtonClick,
  onTryAnotherMethodClick,
}) => (
  <FullScreenModal open showCloseButton onCancel={onCampaignsButtonClick}>
    <Wrapper>
      <Container>
        {isFailed ? (
          <StyledErrorIcon width={40} height={40} />
        ) : (
          <ExclamationIcon width={40} height={40} />
        )}
        <TextContainer>
          <Title>{title}</Title>
          <Text>{text}</Text>
        </TextContainer>
        <Buttons>
          {isFailed ? (
            <GreyTextButton
              loading={isRetrying}
              disabled={isRetrying}
              onClick={onTryAnotherMethodClick}
            >
              Try another payment method
            </GreyTextButton>
          ) : (
            <>
              {isLoading && (
                <PrimaryDottedButton onClick={onBalanceButtonClick}>
                  Go to Balance
                </PrimaryDottedButton>
              )}
              <GreyTextButton onClick={onCampaignsButtonClick}>
                Go to campaigns
              </GreyTextButton>
            </>
          )}
        </Buttons>
      </Container>
    </Wrapper>
  </FullScreenModal>
)
